module.exports = {
    props: {
        id: {
            required: true
        }
    },
    template: `<a v-bind:href="'/properties/' + id" target="_blank"><slot></slot></a>`
}



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/components/parsed/property-link.js